/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Stat_TeamsInputs */

const cs_settings_teams_stat_teams = /** @type {(inputs: Settings_Teams_Stat_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Týmy`)
};

const en_settings_teams_stat_teams = /** @type {(inputs: Settings_Teams_Stat_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

/**
* | output |
* | --- |
* | "Teams" |
*
* @param {Settings_Teams_Stat_TeamsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_stat_teams = /** @type {((inputs?: Settings_Teams_Stat_TeamsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Stat_TeamsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_stat_teams(inputs)
	return cs_settings_teams_stat_teams(inputs)
});